<template>
    <div>
      <div uk-alert class="uk-margin-small">
        <div class="uk-grid">
            <div class="uk-flex uk-flex-left uk-flex-middle uk-width-1-3">
              <div></div>
              <span :uk-icon="icon"></span>
              <small>{{message}}</small>
            </div>
            <div class="uk-flex uk-flex-center uk-flex-middle uk-width-1-3">
              <small><a :href="link" uk-toggle>{{linkText}}</a></small>
            </div>
            <div class="uk-flex uk-flex-center uk-width-1-3">
              <button class="uk-button uk-button-primary" :uk-toggle="buttonLink"><small>{{buttonText}}</small></button>
            </div>
          <div v-if="close">
            <a class="uk-alert-close" uk-close uk-dark></a>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
    export default {
      name: 'alert',
      props: ['icon', 'message', 'link', 'linkText', 'buttonLink', 'buttonText', 'close']
    }
</script>

<style scoped>

</style>
